import { createDecorator } from 'vue-class-component'

export default function Getter(getterType: string) {
  return createDecorator((componentOption, key) => {
    componentOption.computed = !componentOption.computed ? {} : componentOption.computed
    componentOption.computed[key] = function() {
      return (this.$store as any).getters[getterType]
    }
  })
}
